import { SQUARE_ASPECTS_STRING } from '@anm/data/aspects';

import { TemplatePage } from './types';

const holidaysPage: TemplatePage = {
  header: {
    color: '#F69398',
    icon: 'images/video-templates/holiday-occasion.jpg',
    title: 'Holiday Video Templates Collection',
    title_meta: '200+ Free Holiday Video Templates',
    description_meta:
      'Spread some festive cheer to your audience with Wave.video’s 200+ customizable holiday video templates.',
    description:
      'Spread some festive cheer to your audience with these 200+ customizable and free holiday video templates. Pick ' +
      'a template of your choice and surprise your social media followers, customers, colleagues, or anyone else with a ' +
      'beautiful holiday video.'
  },
  footer: {
    category: 'Holidays',
    description:
      'With the help of Wave.video’s broad range of editable holiday video templates, you can create attention-grabbing ' +
      'videos for your social media, blog, website, or email newsletter in minutes. All the templates are free and easy ' +
      'to personalize to suit your brand and topic.'
  },
  content: [
    {
      type: 'slider',
      title: 'Christmas Video Templates',
      name: 'holidays-christmas',
      search: {
        category: '/Holidays & Occasions/Christmas',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Independence Day Video Templates',
      name: 'holidays-independence-day',
      search: {
        category: '/Holidays & Occasions/Independence Day',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Easter Video Templates',
      name: 'holidays-easter',
      search: {
        category: '/Holidays & Occasions/Easter',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Father’s Day Video Templates',
      name: 'holidays-fathers-day',
      search: {
        category: "/Holidays & Occasions/Father's Day",
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Halloween Video Templates',
      name: 'holidays-halloween',
      search: {
        category: '/Holidays & Occasions/Halloween',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Back to School Video Templates',
      name: 'holidays-back-to-school',
      search: {
        category: '/Holidays & Occasions/Back to School',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Labor Day Video Templates',
      name: 'holidays-labor-day',
      search: {
        category: '/Holidays & Occasions/Labor Day',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Valentine’s Day Video Templates',
      name: 'holidays-valentines-day',
      search: {
        category: "/Holidays & Occasions/Valentine's Day",
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Thanksgiving Video Templates',
      name: 'holidays-thanksgiving',
      search: {
        category: '/Holidays & Occasions/Thanksgiving',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Mother’s Day Video Templates',
      name: 'holidays-mothers-day',
      search: {
        category: "/Holidays & Occasions/Mother's Day",
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Observances Video Templates',
      name: 'holidays-observances',
      search: {
        category: '/Holidays & Occasions/Observances',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'stocks',
      title: 'holiday & Occasions',
      search: { name: 'holiday' }
    },
    { type: 'calendar' }
  ]
};

export default holidaysPage;
